export default "__VITE_ASSET__DtQj$fU1__"